export const LOGIC_OPERATORS = {
  AND: 'AND',
  OR: 'OR',
  MISSING: 'MISSING',
  EXISTS: 'EXISTS',
  CONTAINS: 'CONTAINS',
  DOES_NOT_CONTAIN: 'DOES_NOT_CONTAIN',
  EQUALS: 'EQUALS',
  NOT_EQUALS: 'NOT_EQUALS',
  GT: 'GT',
  GTE: 'GTE',
  LT: 'LT',
  LTE: 'LTE',
  /** Rank-order: subject option is ranked above the reference option (lower rank number). */
  BEFORE: 'BEFORE',
  /** Rank-order: subject option is ranked below the reference option (higher rank number). */
  AFTER: 'AFTER',
} as const;

export type LogicOperator = (typeof LOGIC_OPERATORS)[keyof typeof LOGIC_OPERATORS];
